import { getComponentByType } from './ComponentPicker/componentTypes';
import BaseComponent from './IdeaComponents/BaseComponent';

const DefaultComponent = ({ component }) => (
  <BaseComponent
    component={component}
    isOwner={false}
    icon={getComponentByType(component.type)?.icon || <></>}
  >
    <div className="p-4">
      <h3 className="font-medium text-[var(--text-primary)] mb-3 text-lg">
        {component.title || `Unsupported Component: ${component.type}`}
      </h3>
      <pre className="text-xs text-[var(--text-secondary)]">
        {JSON.stringify(component.data, null, 2)}
      </pre>
    </div>
  </BaseComponent>
);

export default function ComponentLoader({ 
  component, 
  onUpdate, 
  onDelete, 
  isOwner, 
  refreshSidebar, 
  onReorder,
  type,
  data,
  isReadOnly = false,
  showPreviewMode = false 
}) {
  // Support both component object and separate type/data props
  const actualComponent = component || { type, data, title: '', id: '' };
  const componentType = getComponentByType(actualComponent.type);
  
  if (!componentType) {
    return <DefaultComponent component={actualComponent} />;
  }

  const SpecificComponent = componentType.component;
  const disclaimer = componentType.aiExcluded ? "The project AI has limited or no access to this component's data." : null;
  
  // For preview mode, render without BaseComponent wrapper
  if (showPreviewMode) {
    return (
      <div className="preview-mode">
        <SpecificComponent 
          component={actualComponent}
          onUpdate={isReadOnly ? undefined : onUpdate}
          refreshSidebar={refreshSidebar}
          isReadOnly={isReadOnly}
        />
      </div>
    );
  }
  
  return (
    <BaseComponent
      component={actualComponent}
      onUpdate={isReadOnly ? undefined : onUpdate}
      onDelete={isReadOnly ? undefined : onDelete}
      isOwner={isOwner && !isReadOnly}
      icon={componentType.icon}
      disclaimer={disclaimer}
      onReorder={onReorder}
    >
      <SpecificComponent 
        component={actualComponent}
        onUpdate={isReadOnly ? undefined : onUpdate}
        refreshSidebar={refreshSidebar}
        isReadOnly={isReadOnly}
      />
    </BaseComponent>
  );
}